let object = {
    author: 'Yumata',
    github: 'https://github.com/yumata/lampa-source',
    css_version: '3.3',
    app_version: '3.3',
    // Идентификатор платформы/бренда. На сборке токен vi3000 заменяется на бренд
    // (см. lampa-web/brands) — бэкенд по нему привязывает регистрацию к нужному боту.
    platform: 'vi3000',
    apk_link_download: 'https://github.com/lampa-app/LAMPA/releases/download/v1.12.3/app-lite-release.apk',
    // Имя Telegram-бота бренда. На сборке 'vi3000_bot' заменяется на бренд
    // (см. lampa-web/brands; для lord67 -> 'lord_67_bot' — точечное правило в
    // lord67/brand.json идёт ПЕРЕД общим vi3000). Device-флоу всё равно берёт
    // актуальное имя из ответа бэкенда (result.bot_username), это — фолбэк.
    bot_username: 'vi3000_bot'
}

let plugins = []

// Текущее выбранное зеркало бренд-API (авторизация, аналитика, история просмотра).
// Заполняется на старте самым быстрым рабочим зеркалом из api_mirrors
// (см. core/mirrors.js). Пустая строка -> берётся api_mirrors[0].
let selected_api = ''

Object.defineProperty(object, 'app_digital', { get: ()=> parseInt(object.app_version.replace(/\./g,'')) })
Object.defineProperty(object, 'css_digital', { get: ()=> parseInt(object.css_version.replace(/\./g,'')) })

Object.defineProperty(object, 'plugins', { 
    get: ()=> plugins,
    set: (plugin)=> {
        if(typeof plugin == 'object' && typeof plugin.type == 'string'){
            plugins.push(plugin)
        }
    }
})

/**
 * Ссылка на GitHub с файлами приложения
 */
Object.defineProperty(object, 'github_lampa', {
    get: ()=> window.lampa_settings.fix_widget ? 'http://lampa.mx/' : 'https://yumata.github.io/lampa/',
    set: ()=> {}
})

/**
 * Старые зеркала, которые не используются больше, но могут быть полезны для обратной совместимости
 */
Object.defineProperty(object, 'old_mirrors', { 
    get: ()=> ['cub.rip', 'standby.cub.red', 'kurwa-bober.ninja', 'nackhui.com'],
    set: ()=> {}
})

/**
 * Зеркала CUB-контента: каталоги, данные о фильмах, постеры, реакции,
 * обсуждения, реклама, метрики и т.д. Это общий публичный сервис CUB.
 * Фейловер между зеркалами при ошибке запроса делает reguest.js.
 *
 * Геттер возвращает каждый раз НОВЫЙ массив — это важно: reguest.js при
 * фейловере мутирует полученный список (Arrays.remove), и мы не должны
 * портить исходные данные.
 *
 * Состояние на 2026-09-25 (проверено с Mac, с сервера в RU и через прокси в NL):
 * cub.best — Cloudflare, живой отовсюду; cubnotrip.top — живой из RU, но режет
 * часть зарубежных сетей (SYN дропается → 30 с таймаута); cub.red — наоборот,
 * живой из-за рубежа, из RU не отвечает. durex.monster — протух TLS-сертификат,
 * cub.rip — DNS не резолвится, cub.black — только сайт, без tmdb.-поддомена.
 * Актуальный список апстрима: yumata/lampa-source, src/core/manifest.js.
 */
Object.defineProperty(object, 'cub_mirrors', {
    get: ()=> ['cub.best', 'cubnotrip.top', 'cub.red'],
    set: ()=> {}
})

/**
 * Зеркала бренд-API: главное (api-m) + резервное (api-r).
 * Через них идут авторизация, аналитика и история просмотра (cub_site).
 * На сборке токен vi3000 заменяется на нужный бренд (см. lampa-web/brands),
 * поэтому здесь зеркала всегда пишутся через домен vi3000.
 * Самое быстрое рабочее зеркало выбирается на старте (см. core/mirrors.js).
 *
 * Геттер возвращает каждый раз НОВЫЙ массив (как и cub_mirrors) — reguest.js
 * мутирует список при фейловере.
 */
Object.defineProperty(object, 'api_mirrors', {
    get: ()=> ['api-m.vi3000.top'],
    //get: ()=> ['localhost:3002'],
    set: ()=> {}
})

/**
 * Зеркала для сокета синхронизации — на бренд-API.
 */
Object.defineProperty(object, 'soc_mirrors', {
    get: ()=> ['api-m.vi3000.top'],
    //get: ()=> ['localhost:3002'],
    set: ()=> {}
})

/**
 * Текущий домен CUB-контента (cub.best). Фейловер между cub_mirrors делает reguest.js.
 */
Object.defineProperty(object, 'cub_domain', {
    get: ()=> object.cub_mirrors[0]
})

/**
 * Хост бренд-API (авторизация, аналитика, история). Возвращает выбранное на
 * старте самое быстрое рабочее зеркало из api_mirrors, либо первое по умолчанию.
 * Сеттер позволяет core/mirrors.js переключать активное зеркало.
 */
Object.defineProperty(object, 'cub_site', {
    get: ()=> object.api_mirrors.indexOf(selected_api) >= 0 ? selected_api : object.api_mirrors[0],
    set: (to)=> { selected_api = to }
})

/**
 * Ссылка на сайт CUB
 */
Object.defineProperty(object, 'qr_site', { 
    get: ()=> {
        return object.cub_domain+'/img/other/qr-code-strong.png'
    } 
})

/**
 * Ссылка на QR для добавления устройства
 */
Object.defineProperty(object, 'qr_device_add', { 
    get: ()=> {
        return object.cub_domain+'/img/other/qr-add-device.png'
    } 
})

export default object